import OktaAuth from "@okta/okta-auth-js";
import { getEnvConfig } from "../config/config";

export const oktaAuth = new OktaAuth({
  issuer: getEnvConfig().Okta.issuer,
  clientId: getEnvConfig().Okta.clientId,
  redirectUri: window.location.origin + "/implicit/callback",
});
